import { SVG_ENUM } from "../../enums";
import { lazy, Suspense } from "react";

type P = {
  type: SVG_ENUM;
  className?: string;
};

const EyeSVG = lazy(() => import("../../assets/svg/EyeSVG"));
const CrossedEyeSVG = lazy(() => import("../../assets/svg/CrossedEyeSVG"));
const CloseCircleSVG = lazy(() => import("../../assets/svg/CloseCircleSVG"));
const CloseCircleGraySVG = lazy(
  () => import("../../assets/svg/CloseCircleGraySVG")
);
const CloudUploadSVG = lazy(() => import("../../assets/svg/CloudUploadSVG"));
const LogoSVG = lazy(() => import("../../assets/svg/LogoSVG"));
const FilterSVG = lazy(() => import("../../assets/svg/FilterSVG"));
const PauseCircleSVG = lazy(() => import("../../assets/svg/PauseCircleSVG"));
const EPFailSVG = lazy(() => import("../../assets/svg/EPFailSVG"));
const EPSuccessSVG = lazy(() => import("../../assets/svg/EPSuccessSVG"));
const PlayCircleSVG = lazy(() => import("../../assets/svg/PlayCircleSVG"));
const BackChevronSVG = lazy(() => import("../../assets/svg/BackChevronSVG"));
const ShoppingCartSVG = lazy(() => import("../../assets/svg/ShoppingCartSVG"));
const TagSVG = lazy(() => import("../../assets/svg/TagSVG"));
const UsersSVG = lazy(() => import("../../assets/svg/UsersSVG"));
const StopSignSVG = lazy(() => import("../../assets/svg/StopSignSVG"));
const EditSVG = lazy(() => import("../../assets/svg/EditSVG"));
const SquareCheckSVG = lazy(() => import("../../assets/svg/SquareCheckSVG"));
const ChevronUpSVG = lazy(() => import("assets/svg/ChevronUpSVG"));
const ChevronDownSVG = lazy(() => import("assets/svg/ChevronDownSVG"));
const ArrowLeftSVG = lazy(() => import("assets/svg/ArrowLeftSVG"));
const TrendingUpSVG = lazy(() => import("assets/svg/TrendingUpSVG"));
const RefreshSVG = lazy(() => import("assets/svg/RefreshSVG"));

const SVG = ({ type, className = "" }: P) => {
  const getSvg = () => {
    switch (type) {
      case SVG_ENUM.LOGO:
        return <LogoSVG className={className} />;
      case SVG_ENUM.EYE:
        return <EyeSVG className={className} />;
      case SVG_ENUM.CROSSED_EYE:
        return <CrossedEyeSVG className={className} />;
      case SVG_ENUM.CLOSE_CIRCLE:
        return <CloseCircleSVG className={className} />;
      case SVG_ENUM.CLOSE_CIRCLE_GRAY:
        return <CloseCircleGraySVG className={className} />;
      case SVG_ENUM.CLOUD_UPLOAD:
        return <CloudUploadSVG className={className} />;
      case SVG_ENUM.FILTER:
        return <FilterSVG className={className} />;
      case SVG_ENUM.PAUSE_CIRCLE:
        return <PauseCircleSVG className={className} />;
      case SVG_ENUM.EP_FAIL:
        return <EPFailSVG className={className} />;
      case SVG_ENUM.EP_SUCCESS:
        return <EPSuccessSVG className={className} />;
      case SVG_ENUM.PLAY_CIRCLE:
        return <PlayCircleSVG className={className} />;
      case SVG_ENUM.BACK_CHEVRON:
        return <BackChevronSVG className={className} />;
      case SVG_ENUM.SHOPPING_CART:
        return <ShoppingCartSVG className={className} />;
      case SVG_ENUM.TAG:
        return <TagSVG className={className} />;
      case SVG_ENUM.USERS:
        return <UsersSVG className={className} />;
      case SVG_ENUM.STOP_SIGN:
        return <StopSignSVG className={className} />;
      case SVG_ENUM.EDIT:
        return <EditSVG className={className} />;
      case SVG_ENUM.SQUARE_CHECK:
        return <SquareCheckSVG className={className} />;
      case SVG_ENUM.CHEVRON_UP:
        return <ChevronUpSVG className={className} />;
      case SVG_ENUM.CHEVRON_DOWN:
        return <ChevronDownSVG className={className} />;
      case SVG_ENUM.ARROW_LEFT:
        return <ArrowLeftSVG className={className} />;
      case SVG_ENUM.TRENDING_UP:
        return <TrendingUpSVG className={className} />;
      case SVG_ENUM.REFRESH:
        return <RefreshSVG className={className} />;
      default:
        return null;
    }
  };

  return <Suspense fallback="">{getSvg()}</Suspense>;
};

export default SVG;
